import { render, staticRenderFns } from "./fssContractList.vue?vue&type=template&id=2427d203&scoped=true&"
import script from "./fssContractList.vue?vue&type=script&lang=js&"
export * from "./fssContractList.vue?vue&type=script&lang=js&"
import style0 from "./fssContractList.vue?vue&type=style&index=0&id=2427d203&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2427d203",
  null
  
)

export default component.exports